import { Card } from '@iris/react-components/Card';
import { Sheet } from '@iris/react-components/Sheet';
import clsx from 'clsx';

import { ConnectedEmailOwner } from 'reaxl-email';
import {
    AvailableOffers,
} from 'reaxl-wallet';

/**
 * IncentivesSheet  is a modal that displays the available offers in the left column and the email form in the right column
 *
 * @component
 * @param {Object} props - The component props
 * @param {React.ReactNode} props.trigger - The trigger element that opens the sheet
 * @param {Object} props.emailOwnerProps - Props to pass to the ConnectedEmailOwner component
 * @param {Array} props.availableOffers - Array of available offers to display
 * @param {boolean} props.open - Boolean that actually controls the incentive sheet open/closed state
 * @param {boolean} props.isXs - Boolean for the xs breakpoint
 * @param {Function} props.setIsIncentivesSheetOpen - Function to control the sheet's open/closed state, used to close sheet after sending a lead
 * @param {boolean} props.isIncentivesSheetOpen - Current state of whether the incentives sheet is open
 * @param {string} [props.className=''] - Additional CSS classes to apply to the wrapper div
 * @param {Function} props.handleIncentivesSheetClose - Function to close the incentive sheet and open the additional inventory modal when an email is submitted
 * @returns {JSX.Element|null} The IncentivesSheet component
 *
 */
export default function IncentivesSheet({ trigger, emailOwnerProps, availableOffers, isXs, setIsIncentivesSheetOpen, isIncentivesSheetOpen, className = '', handleIncentivesSheetClose }) {
    if (!trigger) {
        return null;
    }

    return (
        <div
            data-cmp="incentivesSheet"
            className={className}
        >
            <Sheet
                trigger={trigger}
                desktopPosition="center"
                title="Available offers"
                bodyClassName={clsx('iris:flex iris:w-full iris:md:w-[900px] iris:md:h-[600px] iris:md:max-h-[600px]', { 'iris:flex-col iris:overflow-scroll': isXs, 'iris:flex-row iris:overflow-hidden iris:gap-4': !isXs })}
                modal={isIncentivesSheetOpen}
                onOpenChange={(isOpen) => {
                    if (!isOpen) {
                        setIsIncentivesSheetOpen(false);
                    }
                }}
                open={isIncentivesSheetOpen}
            >
                <Card className={clsx('iris:border-0', { 'iris:w-7/12 iris:overflow-y-auto iris:pt-0 iris:pl-0': !isXs, 'iris:w-full iris:mb-4 iris:px-0': isXs })}>
                    <Card.Content>
                        <AvailableOffers
                            offers={availableOffers}
                            wrappedInModal
                        />
                    </Card.Content>
                </Card>

                <Card className={clsx('iris:self-start', { 'iris:w-5/12 iris:overflow-y-auto': !isXs, 'iris:w-full iris:mb-4': isXs })}>
                    <Card.Content>
                        <ConnectedEmailOwner
                            handleIncentivesSheetClose={handleIncentivesSheetClose}
                            isIncentivesSheet
                            {...emailOwnerProps}
                        />
                    </Card.Content>
                </Card>
            </Sheet>
        </div>
    );
}
